export enum IFollowUpArea {
  BEFORE_TRAVEL = 'beforeTravel',
  AFTER_ARRIVAL = 'afterArrival'
}

export enum RefusalGrounds {
  FINANCE = 'Financial requirements/documents',
  ENGLISH = 'English language proficiency',
  CREDIBILITY = 'Credibility or interview',
  CAS = 'Incorrect details on my CAS',
  COURSE_OR_QUALIFICATIONS = 'Issues with my course or qualifications',
  OTHER = 'Other'
}

export enum AppliedAdminReviewStatus {
  YES = 'Yes',
  NO = 'No',
  NONE = "I don't know"
}
